import React from 'react';
import MapView from "./MapView";
import LopQuyHoach from '../QuyHoach/LopQuyHoach';
import LopHienTrang from "../HienTrang/LopHienTrang";
import Drawing from "../Drawing";
import setup from "../../Containers/setup";
import RightPanel from "./RightPanel";
import { useSelector } from "react-redux";
import PanelQuyHoachInfo from "../QuyHoach/PanelQuyHoachInfo";
import { store } from '../../Redux/Store';
import Type from '../../Redux/Type';
import { MarkerWithLabel } from 'react-google-maps/lib/components/addons/MarkerWithLabel';
import { onCloseRightPanel, onOpenRightPanel } from '../../Containers/RightPanelAction';
import { getSearchList } from '../../Containers/Search';
import { convertLatLonToXY } from '../../Containers/Converter';
import { onMoveToMap } from '../../Containers/MapView';
import LopChuQuyen from '../HienTrang/LopChuQuyen';

const Container = () => {
    const { typeMapId, refMapView } = useSelector(state => state.mapView)
    const userInfo = useSelector(state => state.userInfo);
    const {
        markerPosition,
        pickMapOn,
        modeSearch,
        loadingSearch
    } = useSelector(state => state.searchState);

    const onDragMarkerPickSearchEnd = (ev) => {
        let lat = ev.latLng.lat()
        let lng = ev.latLng.lng()
        store.dispatch({ type: Type.SET_SEARCH, route: 'markerPosition', value: { lat: lat, lng: lng } })
    }
    const getOnClickEvent = (ev) => {
        // 
        if (refMapView && pickMapOn === true) {
            //   draggableCursor: `url(${process.env.PUBLIC_URL}/images/icons/pin.png) 10 10 , crosshair `
            let lat = ev.latLng.lat()
            let lng = ev.latLng.lng()
            store.dispatch({ type: Type.SET_SEARCH, route: 'markerPosition', value: { lat: lat, lng: lng } })
        }
    }
    const pinICON = process.env.PUBLIC_URL + '/images/icons/pin.png'

    const onCallAPISearch = () => {

        let resultconvert = convertLatLonToXY({ latitude: markerPosition.lat, longitude: markerPosition.lng })
        let payload = {
            MaDvhc: 0,//wardSelected.searchID,
            SoTo: '',
            SoThua: '',
            TenChu: '',
            Point: `POINT (${resultconvert.y} ${resultconvert.x})`,
            Position: { Longitude: markerPosition.lng, Latitude: markerPosition.lat },
        };
        onCloseRightPanel()
        store.dispatch({ type: Type.SET_SEARCH, route: 'loadingSearch', value: true });
        store.dispatch({ type: Type.SET_SEARCH, route: 'pickMapOn', value: false });
        let onSuccess = (statusCode, response) => {
            // setLoading(false);
            document.getElementById('conten-point-show').style.filter = 'unset'
            document.getElementById('loading-content-search').style.display = 'none'
            store.dispatch({ type: Type.SET_SEARCH, route: 'loadingSearch', value: false });
            if (statusCode === 200) {
                if (response.length) {
                    store.dispatch({ type: Type.SET_SEARCH, route: 'listResult', value: response });
                    onOpenRightPanel('result')
                }
                else
                    return null;
                // setWarningMessage('Không tìm thấy kết quả nào')
            } else {
                // setErrorMessage(response)
                return null;
            }
        };
        getSearchList(modeSearch, payload, onSuccess);
    };


    const MarkerClickEvt = (ev) => {
        let idDiv = ev.target.id
        if (ev && ev.target) {

            switch (idDiv) {
                case 'btn-point-huy':
                    store.dispatch({ type: Type.SET_SEARCH, route: 'markerPosition', value: null })
                    store.dispatch({ type: Type.SET_SEARCH, route: 'pickMapOn', value: false })
                    break;
                case 'btn-point-submit':
                    document.getElementById('conten-point-show').style.filter = 'blur(1px)'
                    document.getElementById('loading-content-search').style.display = 'block'
                    onCallAPISearch()
                    break;
                case 'btn-point-mini':
                    document.getElementById('content-point-mini').style.display = 'block'
                    document.getElementById('conten-point-show').style.display = 'none'
                    onMoveToMap({ lat: markerPosition.lat, lng: markerPosition.lng })
                    break;
                case 'content-point-mini':
                    document.getElementById('content-point-mini').style.display = 'none'
                    document.getElementById('conten-point-show').style.display = 'block'
                    onMoveToMap({ lat: markerPosition.lat, lng: markerPosition.lng })
                    break;
                default:
                    break;
            }
        }
    }

    const mouseOverPoint = (ev) => {
        if (ev && ev.target) {
            let idDiv = ev.target.id
            if (idDiv) {
                let d = document.getElementById(idDiv)
                switch (idDiv) {
                    case 'btn-point-huy':
                        d.style.textDecoration = 'underline'
                        break;
                    case 'btn-point-submit':
                        d.style.textDecoration = 'underline'
                        break;
                    case 'btn-point-mini':
                        d.style.color = 'rgb(0, 120, 212)'
                        break;
                    default:
                        break;
                }
            }
        }
    }
    const mouseOutPoint = (ev) => {
        if (ev && ev.target) {
            let idDiv = ev.target.id
            if (idDiv) {
                let d = document.getElementById(idDiv)
                switch (idDiv) {
                    case 'btn-point-huy':
                        d.style.textDecoration = 'unset'
                        break;
                    case 'btn-point-submit':
                        d.style.textDecoration = 'unset'
                        break;
                    case 'btn-point-mini':
                        d.style.color = 'rgb(95, 95, 95)'
                        break;
                    default:
                        break;
                }
            }
        }

    }
    return (

        <div style={styles.container}>

            <div style={styles.mapContainer} id="Main-Content">
                {/* <MapV2 center={setup.startCoordinate} zoomOption={setup.defaultZoom} /> */}
                <MapView
                    googleMapURL={setup.googleMapURLProduct}
                    //googleMapURL={setup.googleMapURLDev}
                    // googleMapURL={process.env.NODE_ENV === 'production' ? process.env.REACT_APP_MAP_PRODUCT : process.env.REACT_APP_MAP_DEV}
                    loadingElement={<div style={{ height: `100%` }} />}
                    containerElement={<div style={styles.mapView} />}
                    mapElement={<div style={{ height: `100%` }} />}
                    zoomControl={false}
                    defaultCenter={setup.startCoordinate}
                    mapTypeId={typeMapId}
                    onClick={getOnClickEvent}
                >
                    {
                        markerPosition ? <MarkerWithLabel
                            onClick={MarkerClickEvt}
                            draggable={true}
                            labelAnchor={(20, 20)}
                            labelClass={'content-point'}
                            onMouseOver={mouseOverPoint}
                            onMouseOut={mouseOutPoint}
                            onDragEnd={onDragMarkerPickSearchEnd}
                            icon={{ url: pinICON, strokeWeight: 1, scale: 2 }}
                            position={{ lat: markerPosition.lat, lng: markerPosition.lng }}
                            labelStyle={{ fontSize: "12px", padding: "5px 10px", borderRadius: 5, background: 'white' }}
                        >
                            <ContentMarker location={markerPosition} />
                        </MarkerWithLabel> : null
                    }
                    <LopChuQuyen />
                    <LopHienTrang />
                    <LopQuyHoach />
                    <Drawing />
                </MapView>
            </div>
            <RightPanel />
            <PanelQuyHoachInfo />
        </div>
    )
}

export default Container;

const ContentMarker = (props) => {
    let { location } = props

    return (
        <div style={{ position: 'inherit' }}>
            <div className='loading-content' style={{ display: 'none' }} id="loading-content-search">
                <span>Đang tìm kiếm...</span>
            </div>
            <div id="content-point-mini" style={{ display: 'none' }} className='custom-top-bar' >
                ...
            </div>
            <div id="conten-point-show" className='custom-top-bar' >

                <span className='btn-show-more-pick'>
                    {location.lat + ' , ' + location.lng}
                </span>
                <div className='content-show'>
                    <span id="btn-point-huy" className='btn btn-sm btn-link'>Hủy</span> |
                    <span id="btn-point-submit" className='btn btn-sm btn-link '>Tra cứu</span>
                    <span id="btn-point-mini" title='Thu nhỏ' style={{ float: 'right' }} className='btn btn-sm btn-link'>
                        {'<'}
                    </span>
                </div>
            </div>
        </div>
    )
}

const styles = {
    container: {
        position: 'fixed',
        top: 48,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'row',
    },
    mapContainer: {
        flex: 1, backgroundColor: '#eee', display: 'flex', position: 'relative'
    },
    mapView: {
        top: 0, right: 0,
        bottom: 0,
        left: 0,
        position: "absolute"
    },
};
